import request from '../../../helpers/request';

const createMeterReadings = async (meterId, formValues) => {
  return await request.post(
    `/RentPlace/meter/${meterId}/reading`,
    {
      ...formValues,
      meterReadings: formValues.meterReadings.map((reading) => ({
        ...reading,
        value: reading.value.replace(/\,/g, '.'),
      })),
    },
    'При добавлении показаний произошла ошибка'
  );
};
export default createMeterReadings;
